<template>
  <div class="Package">
    <div class="pack-item" v-for="(it) in list" :key="it.apcUuid">
      <h5>{{it.apcName}}</h5>
      <ul class="item">
        <li>
          <span class="s13 black">套餐项目</span>
          <span class="s12 black">总次数</span>
          <span class="s12 blue">剩余次数</span>
        </li>
        <li v-for="(v, index) in it.acctPackageDesc" :key="index">
          <span class="s13 black">{{v.catalogName}}</span>
          <span class="s12 black">{{v.apdcNumber}}</span>
          <span class="s12 blue">{{v.remainNumber}}</span>
        </li>
      </ul>
      <p class="grey">到期时间:{{it.useEndDate.split('.')[0]}}</p>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
export default {
  name: "Package",
  data() {
    return {
      list: [
        // { name: "更换机油滤清器", text: "", id: 1, time: 1, lave: 2 },
        // { name: "更换机油", text: "", id: 2, time: 1, lave: 2 },
        // { name: "油滤清器", text: "", id: 3, time: 1, lave: 2 },
        // {
        //   name: "ZOOM轻拍全合成机油",
        //   text: "ZM500SN 5W-30（4L）",
        //   id: 4,
        //   time: 1,
        //   lave: 2
        // },
        // {
        //   name: "ZOOM轻拍全合成机油",
        //   text: "ZM500SN 5W-30（4L）",
        //   id: 5,
        //   time: 1,
        //   lave: 2
        // },
        // {
        //   name: "ZOOM轻拍全合成机油",
        //   text: "ZM500SN 5W-30（4L）",
        //   id: 6,
        //   time: 1,
        //   lave: 2
        // }
      ]
    };
  },
  computed: {
    ...mapState({
      carMsg: state => state.carMsg
    })
  },
  mounted() {
    this.getData();
  },
  methods: {
    async getData() {
      //   queryAcctCustPkg
      try {
        // this.$loading("加载中");
        let result = await this.request("/user/queryAcctCustPkg", {
          carUuid: this.carMsg.carUuid // data.userCarList[0].carNo
        });
        let carInfo = JSON.parse(result.data);
        console.log(carInfo);
        this.list = carInfo.acctPackageInfoList;
        // this.carMsg = carInfo.custBaseInfo;
        // this.$store.commit("updateCarMsg", carInfo.custBaseInfo);
        // console.log(result);
        // this.$loadingClose();
      } catch (e) {
        // this.$loadingClose();
        console.log("err", e);
        // this.$error(e.message);
      }
    }
  }
};
</script>

<style lang="less" scoped>
@import "~@/assets/css/style";
.black {
  color: #333;
}
.grey {
  color: #979797;
}
.blue {
  color: #0096ff;
}
.s14 {
  font-size: 14px;
}
.s13 {
  font-size: 13px;
}
.s12 {
  font-size: 12px;
}

.Package {
  background: #f7f7f7;
  padding: 20px;
  height: 100vh;
  overflow: auto;
  .pack-item {
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 0px 10px 0px rgba(210, 210, 210, 0.5);
    border-radius: 5px;
    padding: 10px;
    margin-bottom: 10px;
    h5 {
      font-size: 14px;
    }
    p.grey {
      font-size: 11px;
    }
    .item {
      padding: 5px 0;
      margin: 10px 0;
      border-top: 1px solid #e6e6e6;
      border-bottom: 1px solid #e6e6e6;
      li {
        .flex-center();
        span {
          display: block;
          text-align: center;
          padding: 3px 0;
          width: 60px;
          span {
            white-space: nowrap;
          }
          &:first-child {
            flex: 1;
            text-align: left;
          }
        }
      }
    }
  }
}
.s11 {
  font-size: 11px !important;
}
</style>